module.exports = __webpack_public_path__ + "img/JU-donate-bg-t.e5c5cf53.svg";